<ng-container>
  <a id="pdfViewer" class="emailStatus verificationLink" (click)="pdfViewer()">View</a>
  <a id="pdfDownload" class="emailStatus verificationLink" (click)="pdfDownload()">Download</a>
</ng-container>
